/*
 * @Author: tanyaohua
 * @Date: 2021-11-05 14:00:46
 * @LastEditTime: 2021-11-05 18:16:41
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\fusionSign\directive\trillSignOperationBtns\trillSignOperationBtns.js
 * @Description: 
 */
/**
 * trillSignOperationBtnsModule
 * description: trill渠道下操作按钮
 * author: Qian.qianchen 2019-03-26
 */
'use strict';
angular.module('trillSignOperationBtnsModule', []).directive('trillSignOperationBtns', ['modalDialog', 'trsHttpService', '$filter', function (modalDialog, trsHttpService, $filter) {
    return {
        restrict: 'E',
        replace: false,
        templateUrl: './editingCenter/iWo/fusionSign/directive/trillSignOperationBtns/trillSignOperationBtns_tpl.html',
        scope: {
            selectedArr: '=',
            callback: '&'
        },
        link: function ($scope, iElement, attrs) {
            initStatus();
 
            /**
              * [initStatus description] 
              * @return {[type]}      [description]
              */
            function initStatus() {
                $scope.newOperationParams = {
                    serviceid: 'mlf_fusion',
                    methodname: 'doActionOnMediaTypeAndDocIdsSync',
                    oprType: 'daishen',
                    actionKey: '',
                    OprTime: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    OprTimeStart: '',
                    OprTimeEnd: '',
                };
                $scope.requestData = $scope.callback;
            }
 
            /**
              * [trial description] 抖音撤稿
              * @return {[type]}      [description]
              */
            $scope.withdraw = function () {
                modalDialog.inputModel('撤稿', '撤稿原因（可选）', function (content) { 
                    dealOperParams();
                    $scope.newOperationParams.actionKey = 'tuigao';
                    $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then(function (data) {
                        modalDialog.alertType('撤稿成功', '', 'success', false, function() {
                            $scope.callback();
                        });
                    }, function (data) {
                        $scope.callback();
                    });
                });
            };
 
            /**
              * [directSign description] 直接签发
              * @return {[type]}      [description]
              */
            $scope.directSign = function () {
                modalDialog.confirmModal('签发', '确认签发?', function () {
                    dealOperParams();
                    $scope.newOperationParams.actionKey = 'qianfa';
                    $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'post', true).then(function (data) {
                        modalDialog.alertType('签发成功', '', 'success', false, function () {
                            $scope.callback();
                        });
                    }, function (data) {
                        if (data.REPORTS) {
                        } else {
                            $scope.callback();
                        }
                    });
                });
            };
 
            /**
              * [dealOperParams description]处理参数
              * @return {[type]} [description]
              */
            function dealOperParams() {
                $scope.newOperationParams.mediaTypeDocIds = [];
                $scope.selectedArr.forEach((item) => {
                    $scope.newOperationParams.mediaTypeDocIds.push({
                        MEDIATYPE: item.MEDIATYPE,
                        DOCID: item.METADATAID
                    });
                });
                $scope.newOperationParams.mediaTypeDocIds = JSON.stringify($scope.newOperationParams.mediaTypeDocIds);
            }
        }
    };
}]);
 
